// extracted by mini-css-extract-plugin
module.exports = {"w13nunkg":"w13nunkg"};